angular
    .module('WizApp')
    .service('WizAppAnalyticsService', [
        () => {
            const { wa, ga } = window;

            return {
                trackPageView(url) {
                    if (wa) {
                        wa('track', {
                            documentLocation: `${window.location.protocol}//${window.location.host}${url}`,
                            hitType: 'pageview'
                        });
                    }

                    if (ga) {
                        ga('set', 'page', url);
                        ga('send', 'pageview');
                    }
                },

                resetGaPage() {
                    if (ga) {
                        ga('set', 'page', null);
                    }
                }
            };
        }
    ]);
